<section class="col-seleccion enLocalizador">
  <div class="tituloInt tituloLocalizador">{{ 'VENTAS_PAUSADAS' | translateV2 }}</div>
  <div class="onoffswitch-wrapGeneral filtroCentro" *ngIf="mostrarFiltro()">
    <div class="onoffswitch-wrap checked">
      <div class="onoffswitch" [formGroup]="ventaPausadaForm">
        <input
          type="checkbox"
          name="filtrarCentroCheck"
          id="filtrarCentroCheck"
          class="onoffswitch-checkbox"
          formControlName="filtrarCentro"
          (change)="changefiltrarCentro()"
          [checked]="filtrarCentro"
        />
        <label class="onoffswitch-label" for="filtrarCentroCheck"></label>
      </div>
      <label class="onoffswitch-label-text" for="filtrarCentroCheck">{{
        'FILTRARCENTRO' | translate
      }}</label>
    </div>
  </div>
  <div class="ticket-info localiza-info" [formGroup]="ventaPausadaForm">

    <!-- TPV Input -->
    <div class="inputControl">
      <input
        type="text"
        #tpvInput
        category="ALFANUMERICO"
        formControlName="tpvId"
        placeholder="{{ 'NUM_TPV' | translate }}"
        (focus)="focusValue($event, tpvInput)"
      />
      <img
        *ngIf="tpvInput.value === ''"
        class="svg"
        src="assets/img/icon-search.svg"
        alt="icono busqueda"
      />
      <div
        class="close"
        [ngStyle]="{
          visibility: tpvInput.value === '' ? 'hidden' : 'visible',
          opacity: tpvInput.value === '' ? 0 : 1
        }"
      >
        <a
          title="{{ 'CERRAR' | translateV2 }}"
          (click)="ventaPausadaForm.controls['tpvId'].patchValue('')"
          ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translateV2 }}</span></a
        >
      </div>
    </div>

    <!-- TAG Input -->
    <div class="inputControl">
      <input
        type="text"
        #tagInput
        category="ALFANUMERICO"
        formControlName="tag"
        placeholder="{{ 'TAG' | translate }}"
        (focus)="focusValue($event, tagInput)"
      />
      <img
        *ngIf="tagInput.value === ''"
        class="svg"
        src="assets/img/icon-search.svg"
        alt="icono busqueda"
      />
      <div
        class="close"
        [ngStyle]="{
          visibility: tagInput.value === '' ? 'hidden' : 'visible',
          opacity: tagInput.value === '' ? 0 : 1
        }"
      >
        <a
          title="{{ 'CERRAR' | translateV2 }}"
          (click)="ventaPausadaForm.controls['tag'].patchValue('')"
          ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translateV2 }}</span></a
        >
      </div>
    </div>

    <!-- Identificador Input -->
    <div class="inputControl">
      <input
        class="localizador"
        type="text"
        #identificadorInput
        category="ALFANUMERICO"
        formControlName="identificador"
        placeholder="{{ 'IDENTIFICADOR' | translate }}"
        (focus)="focusValue($event, identificadorInput)"
      />
      <img
        *ngIf="identificadorInput.value === ''"
        class="svg"
        src="assets/img/icon-search.svg"
        alt="icono busqueda"
      />
      <div
        class="close"
        [ngStyle]="{
          visibility: identificadorInput.value === '' ? 'hidden' : 'visible',
          opacity: identificadorInput.value === '' ? 0 : 1
        }"
      >
        <a
          title="{{ 'CERRAR' | translateV2 }}"
          (click)="ventaPausadaForm.controls['identificador'].patchValue('')"
          ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translateV2 }}</span></a
        >
      </div>
    </div>

    <!-- Usuario Input -->
    <div class="inputControl">
      <input
        type="text"
        #usuarioInput
        category="ALFANUMERICO"
        formControlName="usuarioId"
        placeholder="{{ 'USUARIO' | translate }}"
        (focus)="focusValue($event, usuarioInput)"
      />
      <img
        *ngIf="usuarioInput.value === ''"
        class="svg"
        src="assets/img/icon-search.svg"
        alt="icono busqueda"
      />
      <div
        class="close"
        [ngStyle]="{
          visibility: usuarioInput.value === '' ? 'hidden' : 'visible',
          opacity: usuarioInput.value === '' ? 0 : 1
        }"
      >
        <a
          title="{{ 'CERRAR' | translateV2 }}"
          (click)="ventaPausadaForm.controls['usuarioId'].patchValue('')"
          ><span class="cross"></span><span class="sr-only">{{ 'CERRAR' | translateV2 }}</span></a
        >
      </div>
    </div>
  </div>

  <ng-container *ngIf="!ventaPausadaService.loadingBuscador; else cargando2">
    <div
      class="Rtable"
      *ngIf="pagedItems && pagedItems.length !== 0; else noResults"
    >
      <div class="Rtable-row Rtable-row--head">
        <div class="Rtable-cell column-heading cell-ventapausada">
          {{ 'TPVID' | translateV2 }}
        </div>
        <div class="Rtable-cell column-heading cell-ventapausada">{{ 'NOMBRE_TPV' | translateV2 }}</div>
        <div class="Rtable-cell column-heading cell-ventapausada">{{ 'TAG' | translateV2 }}</div>
        <div class="Rtable-cell column-heading cell-ventapausada">{{ 'Identificador' | translateV2 }}</div>
        <div class="Rtable-cell column-heading cell-ventapausada">
          {{ 'CANTIDAD' | translateV2 }}
        </div>
        <div class="Rtable-cell column-heading cell-ventapausada">
          {{ 'TOTAL' | translateV2 }}
        </div>
        <div class="Rtable-cell column-heading cell-ventapausada">
          {{ 'USUARIO' | translateV2 }}
        </div>

        <div class="Rtable-cell column-heading cell-ventapausada">
          {{ 'ACCIONES' | translateV2 }}
        </div>
      </div>

      <div class="listado" id="entradas">
        <!--         <div
          (click)="cargarEntradas(reserva)"
          class="Rtable-row"
          *ngFor="let reserva of pagedItems"
          [ngClass]="selectedReservaClass(reserva)"
        > -->
        <div
          class="Rtable-row"
          *ngFor="let reserva of pagedItems"
          [ngClass]="selectedReservaClass(reserva)"
        >
          <div
            class="Rtable-cell cell-ventapausada"
          >
            <div class="Rtable-cell--content custom-cell">
              {{ reserva.tpvId }}
            </div>
          </div>
          <div class="Rtable-cell cell-ventapausada">
            <div class="Rtable-cell--content custom-cell">
              {{ reserva.nombreTPV }}
            </div>
          </div>
          <div class="Rtable-cell cell-ventapausada">
            <div class="Rtable-cell--content custom-cell">
              {{ reserva.tag || '---' }}
            </div>
          </div>
          <div class="Rtable-cell cell-ventapausada">
            <div class="Rtable-cell--content custom-cell">
              {{ reserva.identificador }}
            </div>
          </div>
          <div class="Rtable-cell cell-ventapausada">
            <div class="Rtable-cell--content custom-cell">
              {{ reserva.cantidad }}
            </div>
          </div>
          <div class="Rtable-cell cell-ventapausada">
            <div class="Rtable-cell--content custom-cell">
              {{ reserva.total }}
            </div>
          </div>
          <div class="Rtable-cell cell-ventapausada">
            <div class="Rtable-cell--content custom-cell">
              {{ reserva.usuarioId }}
            </div>
          </div>
          <div class="Rtable-cell cell-ventapausada">
            <div class="Rtable-cell--content action-cell">
              <button
                class="localInfoPausada"
                title="Localizador Info"
                (click)="openDialogSalePauseDetail(reserva)"
              >
                <img
                  class="svg"
                  src="assets/img/icon-info.svg"
                  alt="Localizador Info"
                />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ul class="pagination" *ngIf="pager.pages && pager.pages.length > 1">
      <li>
        <a
          (click)="setPage(pager.currentPage - 1)"
          title="irInicio"
          class="arrow"
        >
          <img
            class="svg leftarrow"
            src="assets/img/active-arrow.svg"
            alt="icono prev"
          />
        </a>
      </li>
      <!--       <li>
        <a (click)="setPage(pager.currentPage - 1)" title="Previo" class="arrow">
          <img class="svg leftarrow" src="assets/img/active-arrow.svg" alt="icono prev" />
        </a>
      </li> -->
      <li *ngFor="let page of pager.pages">
        <a
          (click)="setPage(page)"
          [ngClass]="{ active: pager.currentPage === page }"
          >{{ page }}</a
        >
      </li>
      <!--       <li>
        <a (click)="setPage(pager.currentPage + 1)" title="Próximo" class="arrow">
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
        </a>
      </li> -->
      <li>
        <a
          (click)="setPage(pager.currentPage + 1)"
          title="irFinal"
          class="arrow"
        >
          <img class="svg" src="assets/img/active-arrow.svg" alt="icono next" />
        </a>
      </li>
    </ul>
  </ng-container>

  <!-- <div class="btn-bottom-wrap" *ngIf="pager.pages && pagedItems.length !== 0">
    <a class="GestionarButton aceptar" >
      <ng-container *ngIf="!loading; else cargando">
        Siguiente
      </ng-container>
    </a>
  </div> -->

  <ng-template #noResults>
    <div
      *ngIf="!ventaPausadaService.noSearch"
      class="DetalleBox__noResultsMessage"
    >
      {{ 'MENSAJE_NO_DATOS' | translateV2 }}
    </div>
  </ng-template>

  <ng-template #cargando class="DetalleBox__noResultsMessage">
    <div class="lds-ring" style="transform: scale(0.6); align-self: center">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </ng-template>

  <ng-template #cargando2>
    <div class="DetalleBox__noResultsMessage">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </ng-template>
</section>
<ticketing-motivos-localizador
  *ngIf="itemsConMotivo"
  [entradas]="itemsConMotivo"
  id="motivosLocalizador"
  style="display:none"
></ticketing-motivos-localizador>
